import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";

export default function HomeNursingBanner({ language, waLink }) {
  const slides = useMemo(() => {
    const isSq = language === "sq";

    return [
      {
        key: "inj",
        img: "/banners/home-nursing-1.jpg",
        kicker: isSq ? "Shërbim në shtëpi" : "At-home service",
        title: isSq ? "Infermier/e • Fizioterapi" : "Nursing • Physiotherapy",
        sub: isSq
          ? "Terapi, grafi në shtëpi, fizioterapi profesionale."
          : "Therapy, home X-ray, professional physiotherapy.",
        msg: isSq
          ? "Përshëndetje! Dua shërbim në shtëpi (infermier/fizioterapi)."
          : "Hi! I need at-home nursing/physiotherapy.",
      },
      {
        key: "ambulance",
        img: "/banners/home-nursing-3.jpg",
        kicker: isSq ? "Shërbim ambulance" : "Ambulance service",
        title: isSq ? "Brenda dhe jashtë Shqipërisë" : "Domestic & international",
        sub: isSq
          ? "Transport mjekësor i sigurt 24/7,staf i specializuar."
          : "Safe medical transport 24/7 with specialized staff.",
        msg: isSq
          ? "Përshëndetje! Dua shërbim ambulance."
          : "Hi! I need an ambulance service.",
      },
    ];
  }, [language]);

  const [idx, setIdx] = useState(0);
  const timerRef = useRef(null);
  const touchRef = useRef({ x: 0, y: 0 });

  const stopAuto = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = null;
  }, []);

  const startAuto = useCallback(() => {
    stopAuto();
    timerRef.current = setInterval(() => {
      setIdx((v) => (v + 1) % slides.length);
    }, 4500);
  }, [slides.length, stopAuto]);

  useEffect(() => {
    startAuto();
    return stopAuto;
  }, [startAuto, stopAuto]);

  const go = (next) => setIdx((next + slides.length) % slides.length);

  const onTouchStart = (e) => {
    const t = e.touches[0];
    touchRef.current = { x: t.clientX, y: t.clientY };
    stopAuto();
  };

  const onTouchEnd = (e) => {
    const t = e.changedTouches[0];
    const dx = t.clientX - touchRef.current.x;
    const dy = t.clientY - touchRef.current.y;

    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) go(idx + 1);
      else go(idx - 1);
    }
    startAuto();
  };

  const onDot = (i) => {
    stopAuto();
    setIdx(i);
    startAuto();
  };

  return (
    <div className="mdk-hn">
      <div className="mdk-hn__viewport" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
        <div className="mdk-hn__track" style={{ transform: `translateX(-${idx * 100}%)` }}>
          {slides.map((s) => (
            <div className="mdk-hn__slide" key={s.key}>
              <img className="mdk-hn__img" src={s.img} alt={s.title} />
              <div className="mdk-hn__overlay" />
              <div className="mdk-hn__content">
                <div className="mdk-hn__kicker">{s.kicker}</div>
                <div className="mdk-hn__title">{s.title}</div>
                <div className="mdk-hn__sub">{s.sub}</div>

                <div className="mdk-hn__actions">
                  <a className="mdk-hn__cta" href={waLink(s.msg)} target="_blank" rel="noreferrer">
                    {language === "sq" ? "WhatsApp" : "WhatsApp"}
                  </a>

                  
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mdk-hn__dots" role="tablist" aria-label="Home nursing slides">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`mdk-hn__dot ${i === idx ? "is-active" : ""}`}
              onClick={() => onDot(i)}
              aria-label={`Go to slide ${i + 1}`}
              type="button"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
